// extracted by mini-css-extract-plugin
module.exports = {"item":"LanguageAcordionList_item__2kPqM"};